<template>
  <section id="deliverySection" class="checkout-section">
    <div class="section-header">
      <h2>{{ resources.blockLabel }}</h2>
      <button
        v-if="!disableEditMode && !editMode && (!skipPostalCode || isMember)"
        @click="backupData(); setEditMode(true);"
        class="btn btn--secondary"
      >
        {{ resources.editCTA }}
      </button>
    </div>

    <delivery-summary v-if="!editMode" />

    <postal-code-form v-if="editMode && !hasSavedAddress" />

    <delivery-method-tile-list />

    <postal-code-form v-if="editMode && hasSavedAddress && !shouldShowAddressPicker" />

    <address-picker v-if="shouldShowAddressPicker" :type="'shipping'" />

    <div v-if="showExclusionError" class="section-row">
      <div class="inline-alert error">
        <span>{{ exclusionResults.errorMessage }}</span>
      </div>
    </div>
    <div v-if="resources.additionalDeliveryMessage" class="section-row">
      <div class="inline-alert notify">
        <span>{{ resources.additionalDeliveryMessage }}</span>
      </div>
    </div>

    <delivery-option-tile-list v-if="!showExclusionError && editMode && enableOptionsChanges" />
    <pickup-person ref="pickupPerson" v-if="editMode && selectedDeliveryMethod.enabled && selectedDeliveryMethod.id === 'pickupPoint'" />
    <postnummer v-if="isPostnummerExist && editMode && selectedDeliveryMethod.enabled && selectedDeliveryMethod.id === 'pickupPoint'" />
    <pick-post v-if="isPickPostExist && editMode && selectedDeliveryMethod.enabled && selectedDeliveryMethod.id === 'pickupPoint'" />

    <div v-if="shouldShowEditModeButtons" class="section-row">
      <div v-if="showEditModeError" class="inline-alert error">
        <span>{{ resources.saveDeliverySettingsWarning }}</span>
      </div>
      <div v-if="!saveDeliveryValidation" class="section-row">
        <div class="inline-alert error">
          <span>{{ resources.deliveryBlockSaveValidationWarning }}</span>
        </div>
      </div>
      <footer v-if="editMode" class="section-footer">
        <button class="btn" @click="saveData" :disabled="!saveDeliveryValidation || showSpinner">
          <div
            :class="['spinner', 'white-spinner', { 'spinner-visible': showSpinner }]"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <template v-if="!showSpinner">
              {{resources.saveDeliverySettingCTA}}
          </template>
        </button>

        <button class="link" @click="revertEdit">{{ resources.cancelCTA }}</button>
      </footer>
    </div>
  </section>
</template>
<script src="./delivery.js">
